import React from 'react';

import PropTypes from 'prop-types';
import { Map, Polyline, InfoWindow } from 'google-maps-react';

import { IntlProvider, injectIntl, intlShape } from 'react-intl';
import FormattedDuration from 'react-intl-formatted-duration';

import styles from './mapStyle.json';

const getSegmentColor = (segment) => {
  if (segment.segmentState === 'ACCEPTED') return '#51deb8';
  switch (segment.overspeed) {
    case 'noOverSpeed': return '#51deb8';
    case 'small': return '#f7e483';
    case 'medium': return '#f7b984';
    case 'large': return '#f08d80';
    case 'xlarge': return '#737b82';
    default: return 'purple';
  }
};

const dashedLineSymbol = {
  path: 'M 0,-1 0,1',
  strokeOpacity: 0.8,
  scale: 3,
};

const getLineProperties = segment => ((segment.GPSFixes < 5) ? ({
  icons: [{
    icon: dashedLineSymbol,
    offset: '0',
    repeat: '15px',
  }],
  strokeOpacity: 0,
}) : ({
  strokeOpacity: 0.8,
  strokeWeight: 3,
}));

const JourneyMap = ({
  onMapReady, onInfoWindowClose, journey: { bounds }, segments, activeSegment = {}, google, onSegmentClick, intl,
}) => {
  const handleOnMapReady = (mapProps, map) => {
    const gBounds = new google.maps.LatLngBounds(bounds && bounds.southwest, bounds && bounds.northeast);
    map.fitBounds(gBounds);
    onMapReady(map);
  };


  return (
    <Map
      google={google}
      containerStyle={{
        width: '60%',
        position: 'relative',
        float: 'left',
      }}
      onReady={handleOnMapReady}
      styles={styles}
      scaleControl
    >
      {segments.map(segment => (
        <Polyline
          key={segment.start}
          path={segment.path.map(([latitude, longitude]) => ({ lat: latitude, lng: longitude }))}
          onClick={() => onSegmentClick(segment)}
          strokeColor={getSegmentColor(segment)}
          {...getLineProperties(segment)}
        />))}

      <InfoWindow
        position={activeSegment.path && {
              lat: activeSegment.path[Math.round(activeSegment.path.length / 2) - 1][0],
              lng: activeSegment.path[Math.round(activeSegment.path.length / 2) - 1][1],
            }}
        visible={activeSegment.path !== undefined}

        onClose={onInfoWindowClose}
      >
        <IntlProvider locale={intl.locale} messages={intl.messages}>
          <div>
            <h4>{intl.formatMessage({ id: 'journeyDetails.speeding' })}</h4>
            <p>
              {intl.formatMessage({ id: 'journeyDetails.parameter.avgSpeed' })}:
              {Math.round(activeSegment.avg)}km/h<br />
              {activeSegment.limit ? `${intl.formatMessage({ id: 'journeyDetails.limit' })}:
                ${activeSegment.limit} km/h` : false}
            </p>
            <p>
              {activeSegment.limit ? `${intl.formatMessage({ id: 'journeyDetails.overspeed' })}:
            ${Math.round(activeSegment.avg - activeSegment.limit)} km/h` : false}<br />
              {intl.formatMessage({ id: 'journeyDetails.parameter.start' })}:
              {intl.formatTime(activeSegment.start)}<br />
              {`${intl.formatMessage({ id: 'journeyDetails.duration' })}: `}
              {activeSegment.duration &&
                <FormattedDuration seconds={activeSegment.duration} textComponent={props => <span {...props} />} />
              }
              <br />
            </p>
            <p>{activeSegment.formatted_address}</p>
          </div>
        </IntlProvider>
      </InfoWindow>
    </Map>
  );
};

JourneyMap.propTypes = {
  intl: intlShape.isRequired,
  journey: PropTypes.object.isRequired,
  activeSegment: PropTypes.object,
  google: PropTypes.object,
  onSegmentClick: PropTypes.func.isRequired,
};

export default injectIntl(JourneyMap);



// WEBPACK FOOTER //
// ./src/components/Journey/JourneyMap/index.js